module.exports = __webpack_public_path__ + "PBSLM-Logo-Open-Area-Inverse.svg";